import React, { useState, useRef, useMemo } from "react";
import {  shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { CategoryEditForm } from "./CategoryEditAddForm";
import { Link } from "react-router-dom";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";
import { useSubheader } from "../../../_metronic/layout";
import { useSnackbar } from "notistack";
import { fetchSingleWixCategory, updateWixCategory} from "../../../actions/wix-categories/wixCategories";


export function WixCategoryEdit({
  history,
  match: {
    params: { id, total },
  },
}) {
  const { enqueueSnackbar } = useSnackbar();


  const initCategory = {
    category_name: "",
    order:"",

  };

  const { categoryForEdit } = useSelector(
    (state) => ({
      categoryForEdit: id
        ? state.wixCategories && state.wixCategories.categoryForEdit
        : undefined,
    }),
    shallowEqual
  );


  // Subheader
  const suhbeader = useSubheader();

  // Tabs
  const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");

  const dispatch = useDispatch()

  // get data
  useMemo(async () => {
    if (id === undefined) {
      return;
    }
    await dispatch(fetchSingleWixCategory(id));

  }, [id, dispatch]);

  

  React.useEffect(() => {
    if (id) {
      suhbeader.setBreadcrumbs([{pathname:'/wix-categories', title:'Wix Categories'},{pathname:'', title:'Edit Category'}]);
    }
 
  }, [])


  const saveCategory = (values) => {
    if (id) {
        dispatch(updateWixCategory(values, id)).then(async (data) => {
        if (data.success) {
          await enqueueSnackbar(data.message, {
            variant: "success",
            autoHideDuration: 1500,
          });
        
          await history.push(`/wix-categories`);
        }
        else{
          await enqueueSnackbar(data.message, {
            variant: "error",
            autoHideDuration: 1500,
          });
        }
      });
    }

  };

  const btnRef = useRef();
  const saveCategoryClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const backToWixCategoriesList = () => {
    history.push(`/wix-categories`);
  };

  return (
    <Card>
      {false && <ModalProgressBar />}
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type='button'
            onClick={backToWixCategoriesList}
            className='btn btn-light'>
            <i className='fa fa-arrow-left'></i>
            Back
          </button>
          {`  `}

          {`  `}
          <button
            type='submit'
            className='btn btn-primary ml-2'
            onClick={saveCategoryClick}>
            Save
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <ul className='nav nav-tabs nav-tabs-line ' role='tablist'>
          <li className='nav-item' onClick={() => setTab("basic")}>
            <Link
              className={`nav-link ${tab === "basic" && "active"}`}
              data-toggle='tab'
              role='tab'
              aria-selected={(tab === "basic").toString()}>
              Category info
            </Link>
          </li>
        </ul>
        <div className='mt-5'>
          {tab === "basic" && (
            <CategoryEditForm
              category={ categoryForEdit || initCategory}
              id={id}
              total={total}
              btnRef={btnRef}
              saveCategory={saveCategory}
            />
          )}

          {/* If you add new tab than add more */}
        </div>
      </CardBody>
      <hr />
      <CardHeader title={""} className='mt-2'>
        <CardHeaderToolbar>
          <button
            type='button'
            onClick={backToWixCategoriesList}
            className='btn btn-light'>
            <i className='fa fa-arrow-left'></i>
            Back
          </button>
          {`  `}

          {`  `}
          <button
            type='submit'
            className='btn btn-primary ml-2'
            onClick={saveCategoryClick}>
            Save
          </button>
        </CardHeaderToolbar>
      </CardHeader>
    </Card>
  );
}
